import { styles } from './CarouselLeadImage.css';
import React, { ReactNode } from 'react';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { ProductCarousel, ProductCarouselProps } from '../ProductCarousel/ProductCarousel';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { GoToLink, GoToLinkProps } from '../GoToLink/GoToLink';
import { Link } from '../PlatformFunctionality';

export type CarouselLeadImageProps = {
  leadImage?: ReactNode;
  leadImageHref?: string;
  linkProps?: GoToLinkProps;
  ctaButton?: ReactNode;
  heading: string;
  productCarouselProps: ProductCarouselProps;
  shouldHideHeadingOnMobile?: boolean;
};

export const CarouselLeadImage = ({
  leadImage,
  leadImageHref,
  linkProps,
  ctaButton,
  heading,
  productCarouselProps,
  shouldHideHeadingOnMobile,
}: CarouselLeadImageProps) => {
  const isDesktop = useBreakpoint('md', 'up');

  return (
    <div className={styles.wrapper}>
      {linkProps ? <GoToLink {...linkProps} className={styles.link} /> : null}
      <div className={styles.container}>
        {leadImage && isDesktop ? (
          leadImageHref ? (
            <Link className={styles.leadContainer} href={leadImageHref}>
              {leadImage}
            </Link>
          ) : (
            <div className={styles.leadContainer}>{leadImage}</div>
          )
        ) : null}
        {shouldHideHeadingOnMobile && !isDesktop ? null : (
          <div className={styles.headingContainer}>
            <DomFont as="h1" className={styles.headingText}>
              {heading}
            </DomFont>
          </div>
        )}
        <div className={styles.carouselContainer}>
          <ProductCarousel {...productCarouselProps} />
        </div>
      </div>
      {ctaButton ? <div className={styles.ctaButton}>{ctaButton}</div> : null}
    </div>
  );
};
